<template>
  <div class="conteiner">
    <div class="col-md-6 offset-md-3">
      <Titulo :sombra="false" titulo='Novidades no meu Instagram' icon="instagram" posicao="center" />
      <InstagramFeed :count="3"
        accessToken="IGAALBZAJqba5hBZAE1ab0FUS0p3QzlDaXJtcjRNcXNBa0VLdlNXZAWhzOS14X0c0eEtSWW5Tb3NseDVwSVQxeThwYUd3VGR6WG1odXFsbjBYN1k4MlhMV3dVRnBReWU0eXN2UVBqZA3dPMjhZAZAWlHN3huZAE9wU1JDZA01ETldXU3pHOAZDZD"
        :pagination="true" />
    </div>
  </div>
</template>

<script>
import InstagramFeed from "vue3-instagram-feed";
import "vue3-instagram-feed/dist/style.css";
import Titulo from "./Titulo.vue";

export default {
  name: 'BlocoInstagram',
  props: {
  },
  components: {
    Titulo,
  },
}
</script>

<style>
@media (max-width: 999px) {
  .instagram-gallery-item {
    max-width: 30% !important;
  }
}

@media (min-width: 1000px) {
  .instagram-gallery-item {
    max-width: 30% !important;
  }
}

.instagram-gallery {
  display: flex;
  flex-wrap: wrap;
  /* margin: -1rem, -1rem; */
  padding-bottom: 3rem;
}

.instagram-gallery-item {
  position: relative;
  /* flex: 1 0 22rem; */
  margin: 5px !important;
  padding: 0px !important;
  border: 0px;
  color: red;
  cursor: pointer;
}

.instagram-gallery-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

#feed_instagram button {
  display: none;
}
</style>